import { getCoverImageUrl } from 'utils/shared/user/getCoverImageUrl';
import AddPhoto from 'svg/AddPhoto';
import ChevronLeft from 'svg/ChevronLeft';
import Share from 'svg/Share';
import Button from 'components/Button';
import classNames from 'styles/utils/classNames';
import RoundIconButton from '../RoundIconButton';

interface Props {
  coverImagePath?: string | null;
  /** Object-URL of a just-picked file, shown until the refetched path arrives. */
  previewImageUrl?: string | null;
  isViewerProfile: boolean;
  onShare: () => void;
  onEditCover?: () => void;
  isUploadingCover?: boolean;
  /** Decided once by the screen; this only renders. */
  showBack?: boolean;
  onBack?: () => void;
  className?: string;
}

/**
 * Split out of the hero because desktop stretches the banner across both grid
 * columns while the identity block below it stays in the content column.
 */
export default function ProfileCover({
  coverImagePath,
  previewImageUrl,
  isViewerProfile,
  onShare,
  onEditCover,
  isUploadingCover = false,
  showBack = true,
  onBack,
  className,
}: Props) {
  const coverImageUrl = previewImageUrl || getCoverImageUrl({ path: coverImagePath });

  return (
    <div
      className={classNames(
        // Full-bleed on mobile, rounded once there's a gutter to round against.
        'relative -mx-4 h-[8.75rem] sm:-mx-6 md:mx-0 md:h-[14.375rem] md:overflow-hidden md:rounded-[1.25rem]',
        className,
      )}
    >
      {coverImageUrl ? (
        <img src={coverImageUrl} alt="" className="size-full object-cover" />
      ) : (
        <div className="size-full bg-gradient-to-br from-brand-fire-700 via-brand-fire-600 to-color-bg-lightmode-invert" />
      )}

      {/* Desktop lifts these two into the page header bar above the content. */}
      <div className="absolute inset-x-0 top-0 flex items-center justify-between p-ds-lg md:hidden">
        {showBack ? (
          <RoundIconButton
            label="Go back"
            onClick={onBack}
            icon={<ChevronLeft className="h-5 w-5" />}
          />
        ) : (
          <span />
        )}

        <Button
          variant="secondary"
          size="xs"
          isInline
          className="border-transparent shadow-fab"
          iconLeft={<Share className="size-4" />}
          onClick={onShare}
        >
          Share
        </Button>
      </div>

      {isViewerProfile && onEditCover && (
        <RoundIconButton
          label="Change cover photo"
          onClick={onEditCover}
          isLoading={isUploadingCover}
          icon={<AddPhoto className="h-4 w-4" />}
          className="absolute bottom-ds-md right-ds-lg"
        />
      )}
    </div>
  );
}
